<script>
export default {
  name: 'SubHeader',
  props: {
    text: {
      type: String,
      required: true,
    },
    length: {
      type: String,
      required: false,
      default: '0',
    },
  },
  methods: {
    decodeHTMLEntities(str) {
      let element = document.createElement('div')
      if (str && typeof str === 'string') {
        // strip script/html tags
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '')
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '')
        element.innerHTML = str
        str = element.textContent
        element.textContent = ''
      }
      return str
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <h4>{{ decodeHTMLEntities(text) }}</h4>
    <h4 v-if="length != 0">{{ length }}</h4>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  @extend %typography-large;
  display: flex;
  justify-content: space-between;

  h4 {
    font-family: 'Object Sans Heavy', sans-serif;
    font-weight: bold;
    color: $darker-gray;
    text-align: left;
    font-size: 1.4rem;
    padding-left: 1rem;
  }
}
</style>
